import { BASE_URL } from "../Services/Endpoints";
import { Profile as DefaultProfileImage } from "../assets/Exportimageicon";

export { DefaultProfileImage };

export const getProfileImageSrc = (image) => {
  if (!image) return DefaultProfileImage;

  if (
    image.startsWith("http://") ||
    image.startsWith("https://") ||
    image.startsWith("data:") ||
    image.startsWith("blob:")
  ) {
    return image;
  }

  const origin = BASE_URL.replace(/\/api\/?$/, "");
  const path = image.startsWith("/") ? image : `/${image}`;
  return `${origin}${path}`;
};
